<template>
  <Layout>
    <!-- WA Notification Banner -->
    <transition name="wa-notif-slide">
      <div v-if="pendingWaConversations.length > 0" class="wa-banner" @click="goToMessenger">
        <div class="wa-banner-left">
          <div class="wa-banner-badge">
            <i class="bx bxl-whatsapp"></i>
            <span class="wa-banner-dot"></span>
          </div>
          <div class="wa-banner-text">
            <span class="wa-banner-label">
              {{ pendingWaConversations.length }} {{ pendingWaConversations.length === 1 ? 'conversa pendente' : 'conversas pendentes' }}
            </span>
            <span class="wa-banner-detail">
              {{ lastWaContactName }}{{ pendingWaConversations.length > 1 ? ' e mais ' + (pendingWaConversations.length - 1) : '' }} · aguardando atendimento
            </span>
          </div>
        </div>
        <div class="wa-banner-right">
          <span class="wa-banner-cta">Abrir Messenger <i class="bx bx-chevron-right"></i></span>
          <button class="wa-banner-close" @click.stop="dismissWaNotifications" title="Dispensar"><i class="bx bx-x"></i></button>
        </div>
      </div>
    </transition>

    <participant-statistic ref="child"></participant-statistic>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- BARRA DE AÇÕES -->
            <div class="row mb-2 align-items-center action-bar">
              <div class="col-sm-12 col-md-auto mb-2">
                <!-- TOGGLE: Todas fichas / Minhas fichas -->
                <div class="btn-group w-100" role="group">
                  <button
                    type="button"
                    class="btn"
                    :class="!showMyParticipants ? 'btn-primary' : 'btn-outline-secondary'"
                    @click="toggleView(false)"
                  >
                    Todas fichas ({{ allParticipantsCount }})
                  </button>
                  <button
                    type="button"
                    class="btn"
                    :class="showMyParticipants ? 'btn-primary' : 'btn-outline-secondary'"
                    @click="toggleView(true)"
                  >
                    Minhas fichas ({{ myParticipantsCount }})
                  </button>
                </div>
              </div>

              <!-- BOTÃO DISTRIBUIR (só mostra para admin type=1, em "Todas fichas" e não em modo seleção) -->
              <div v-if="isUserAdmin && !showMyParticipants && !selectionMode" class="col-auto mb-2">
                <b-dropdown
                  split
                  variant="dark"
                  @click="enableSelection"
                >
                  <template #button-content>
                    <i class="mdi mdi-account-group mr-1"></i> Distribuir
                  </template>
                  <b-dropdown-item @click="enableSelection">
                    <i class="mdi mdi-cursor-pointer mr-2"></i> Distribuir Manual
                    <br>
                    <small class="text-muted">Selecione as fichas e escolha o operador</small>
                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="openAssignAuto">
                    <i class="mdi mdi-auto-fix mr-2"></i> Distribuir Automático
                    <br>
                    <small class="text-muted">Sistema distribui automaticamente</small>
                  </b-dropdown-item>
                </b-dropdown>
              </div>

              <!-- BARRA DE PESQUISA (ocupa espaço restante) -->
              <div class="col mb-2">
                <div class="search-box">
                  <div class="position-relative">
                    <input
                      type="text"
                      class="form-control"
                      v-model="search"
                      :placeholder="searchPlaceholder"
                      @keyup.enter="doSearch"
                    />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-auto mb-2">
                <!-- FILTROS -->
                <button
                  type="button"
                  :class="hasActiveFilters ? 'btn btn-warning' : 'btn btn-primary'"
                  @click="showFilters()"
                >
                  <i class="mdi mdi-filter mr-1"></i> Filtros Avançados
                  <span v-if="hasActiveFilters" class="badge badge-light ml-1">{{ activeFilterCount }}</span>
                </button>
              </div>

              <!-- SELETOR DE COLUNAS -->
              <div class="col-auto mb-2" style="position: relative;" @click.stop>
                <button
                  type="button"
                  class="btn column-toggle-btn"
                  :class="selectedColumnKeys.length ? 'column-toggle-active' : ''"
                  @click="openColumnSelector"
                >
                  <i class="mdi mdi-table-column mr-1"></i>
                  Colunas
                  <span v-if="selectedColumnKeys.length" class="column-count-badge">
                    {{ selectedColumnKeys.length }}
                  </span>
                </button>

                <!-- Dropdown Popover -->
                <div v-if="showColumnDropdown" class="column-selector-dropdown" @click.stop>
                  <div class="cs-header">
                    <strong>Personalizar Colunas</strong>
                    <small class="text-primary">{{ tempSelectedKeys.length }} selecionadas</small>
                  </div>

                  <!-- Busca -->
                  <div class="cs-search">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Buscar campo..."
                      v-model="columnSearch"
                    />
                  </div>

                  <!-- Scrollable area -->
                  <div class="cs-sections-scroll">
                    <!-- Campos Fixos (accordion, inicia fechado) -->
                    <div class="cs-accordion">
                      <div class="cs-accordion-header" @click="colAccFixedOpen = !colAccFixedOpen">
                        <i class="mdi" :class="colAccFixedOpen ? 'mdi-chevron-down' : 'mdi-chevron-right'"></i>
                        <small class="text-muted text-uppercase">Campos Fixos</small>
                        <span class="cs-accordion-count">{{ fixedColumns.length }}</span>
                      </div>
                      <div v-show="colAccFixedOpen" class="cs-accordion-body">
                        <template v-for="col in fixedColumns">
                          <div v-if="col.toggleable" :key="'fixed-' + col.key" class="cs-item" @click="toggleJourneyColumn">
                            <input type="checkbox" :checked="journeyColumnVisible" />
                            <span>{{ col.label }}</span>
                            <i class="mdi mdi-swap-horizontal text-muted ml-auto" style="font-size: 12px;" title="Pode desativar"></i>
                          </div>
                          <div v-else :key="'fixed-' + col.key" class="cs-item disabled">
                            <input type="checkbox" checked disabled />
                            <span>{{ col.label }}</span>
                            <i class="mdi mdi-lock-outline text-muted ml-auto"></i>
                          </div>
                        </template>
                      </div>
                    </div>

                    <!-- Campos Opcionais (accordion, inicia aberto) -->
                    <div class="cs-accordion">
                      <div class="cs-accordion-header" @click="colAccOptionalOpen = !colAccOptionalOpen">
                        <i class="mdi" :class="colAccOptionalOpen ? 'mdi-chevron-down' : 'mdi-chevron-right'"></i>
                        <small class="text-muted text-uppercase">Campos Opcionais</small>
                        <span class="cs-accordion-count">{{ filteredColumns.length }}</span>
                      </div>
                      <div v-show="colAccOptionalOpen" class="cs-accordion-body">
                        <div
                          v-for="col in filteredColumns"
                          :key="'opt-' + col.key"
                          class="cs-item"
                          @click="toggleTempColumn(col.key)"
                        >
                          <input type="checkbox" :checked="tempSelectedKeys.includes(col.key)" />
                          <span>{{ col.label }}</span>
                          <small v-if="col.formName" class="text-muted ml-2">{{ col.formName }}</small>
                        </div>
                      </div>
                    </div>

                    <!-- Controle de Inscrição (accordion, se existir) -->
                    <div v-if="filteredRcColumns.length" class="cs-accordion">
                      <div class="cs-accordion-header" @click="colAccRcOpen = !colAccRcOpen">
                        <i class="mdi" :class="colAccRcOpen ? 'mdi-chevron-down' : 'mdi-chevron-right'"></i>
                        <small class="text-muted text-uppercase">Controle de Inscrição</small>
                        <span class="cs-accordion-count">{{ filteredRcColumns.length }}</span>
                      </div>
                      <div v-show="colAccRcOpen" class="cs-accordion-body">
                        <div
                          v-for="col in filteredRcColumns"
                          :key="'rc-' + col.key"
                          class="cs-item"
                          @click="toggleTempColumn(col.key)"
                        >
                          <input type="checkbox" :checked="tempSelectedKeys.includes(col.key)" />
                          <span>{{ col.label }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Footer -->
                  <div class="cs-footer">
                    <button class="btn btn-sm btn-light" @click="resetColumns">Resetar</button>
                    <button class="btn btn-sm btn-primary" @click="applyColumns">Aplicar</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- BARRA DE SELEÇÃO (quando ativo) -->
            <div class="row mb-2" v-if="selectionMode">
              <div class="col-12">
                <div class="alert alert-info d-flex justify-content-between align-items-center">
                  <span>
                    <strong>({{ selectedParticipants.length }}) Fichas selecionadas</strong>
                  </span>
                  <div style="display:flex;align-items:center;justify-content:center;gap:5px;">
                    <button
                      class="btn btn-sm btn-primary"
                      @click="openAssignManual"
                      :disabled="selectedParticipants.length === 0"
                    >
                      <i class="mdi mdi-account-arrow-right"></i> Atribuir manual
                    </button>
                    <button class="btn btn-sm btn-secondary" @click="cancelSelection">
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- TABELA -->
            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <!-- CHECKBOX (apenas no modo seleção) -->
                    <th v-if="selectionMode" width="3%">
                      <input
                        type="checkbox"
                        @change="toggleSelectAll"
                        :checked="selectedParticipants.length === participants.length && participants.length > 0"
                      />
                    </th>
                    <th>Nome</th>
                    <th v-for="col in activeColumns" :key="'th-' + col.key">{{ col.label }}</th>
                    <th>Grupo</th>
                    <th width="100">Inscrição</th>
                    <th width="100">Atualização</th>
                    <th v-if="needsJourneyInclude" width="140">Jornada</th>
                    <th width="140">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="list in displayParticipants"
                    :key="list.id"
                    class="link"
                    :class="{
                      'inativado': parseInt(list.status) === 5,
                      'table-active': isSelected(list.id)
                    }"
                  >
                    <!-- CHECKBOX -->
                    <td v-if="selectionMode" @click.stop="toggleSelection(list.id)">
                      <input
                        type="checkbox"
                        :checked="isSelected(list.id)"
                        @click.stop="toggleSelection(list.id)"
                      />
                    </td>

                    <td
                      @click="handleRowClick(list)"
                      :style="duplicateClusters[list.id] ? ('border-left: 4px solid ' + duplicateClusters[list.id].color) : null"
                    >
                      <div class="d-flex align-items-center gap-1">
                        <!-- Ícone facial (só aparece se tiver) -->
                        <div v-if="list.facialId" style="width: 24px; flex-shrink: 0;">
                          <img src="@/assets/images/facial-recognition.png" width="20" height="20"/>
                        </div>
                        <div class="flex-grow-1">
                          <div class="d-flex align-items-center gap-1 flex-wrap">
                            <h5 class="font-size-14 mb-0" style="white-space: nowrap;text-overflow: ellipsis;max-width: 275px;overflow: hidden;">
                              {{ list.name }}
                            </h5>
                            <!-- BADGE DO ADMIN ATRIBUÍDO -->
                            <span v-if="list.assigned_admin" class="badge badge-soft-info font-size-11">
                              <i class="mdi mdi-account-circle"></i> {{ list.assigned_admin }}
                            </span>
                            <!-- CHIP DE DUPLICIDADE: a "cola" que amarra o cluster (CPF compartilhado) -->
                            <span
                              v-if="duplicateClusters[list.id] && duplicateClusters[list.id].chip"
                              class="badge font-size-11"
                              :style="{
                                backgroundColor: duplicateClusters[list.id].color + '22',
                                color: duplicateClusters[list.id].color,
                                border: '1px solid ' + duplicateClusters[list.id].color
                              }"
                            >
                              <i class="mdi mdi-link-variant"></i> CPF {{ duplicateClusters[list.id].chip }}
                            </span>
                          </div>
                          <p class="text-muted mb-0">{{ list.email }}</p>
                        </div>
                      </div>
                    </td>
                    <td v-for="col in activeColumns" :key="'td-' + col.key"
                      @click="handleRowClick(list)"
                      style="font-size: 12px !important">
                      {{ getColumnValue(list, col) }}
                    </td>
                    <td @click="handleRowClick(list)">
                      <GroupBadges :participant="list" />
                      <span class="badge font-size-12" :class="{'badge-soft-success': list.need_payment === 1 && list.payment_completed === 1, 'badge-soft-danger': list.need_payment === 1 && list.payment_completed === 0}" style="font-weight: 400; white-space: nowrap;text-overflow: ellipsis;max-width: 260px;overflow: hidden; display:inherit">
                        {{ list.need_payment === 1 && list.payment_completed === 1 ? 'Pagamento Confirmado' : list.need_payment === 1 && list.payment_completed === 0 ? 'Pagamento Pendente' : ''}}
                      </span>
                    </td>
                    <td @click="handleRowClick(list)" style="font-size: 12px !important">{{ list.inscricao }}</td>
                    <td @click="handleRowClick(list)" style="font-size: 12px !important">{{ list.atualizacao }}</td>
                    <td v-if="needsJourneyInclude" @click="handleRowClick(list)">
                      <journey-progress-cell
                        :progress="journeyProgressMap[list.id] || null"
                      />
                    </td>
                    <td @click.stop>
                      <div class="status-wrapper">
                        <!-- Dropdown split para admin/master -->
                        <b-dropdown
                          v-if="isUserAdmin || isUserMaster"
                          split
                          size="sm"
                          :variant="statusVariant[list.status]"
                          class="status-dropdown"
                        >
                          <template #button-content>
                            {{ statusList[list.status] }}
                          </template>
                          <b-dropdown-item-button
                            v-for="(s, idx) in statusList"
                            :key="idx"
                            @click="quickToggleStatus(list, idx)"
                          >
                            {{ s }}
                          </b-dropdown-item-button>
                        </b-dropdown>

                        <!-- Badge estático para operadores/viewers -->
                        <span v-else
                          :class="statusClass[list.status]"
                          class="badge font-size-12 p-2" style="min-width: 120px">
                          {{ statusList[list.status] }}
                        </span>

                        <!-- Ref status (motivo pendência) -->
                        <span
                          v-if="list.ref_status"
                          class="badge font-size-11 p-1 badge-secondary status-ref">
                          {{ refstatusList[list.ref_status] }}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- PAGINAÇÃO -->
            <div class="row">
              <div class="col">
                <div class="float-left">
                  Total de registros: <b>{{ totalRows }}</b>
                </div>
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @change="changePage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODALS -->
    <modal-form v-model="modalForm" :idParticipant="idParticipant" ref="formParticipant" @created="updateList"></modal-form>
    <companion-form v-model="modalFormC" :idParticipant="idParticipant" ref="formCompanion" @created="updateList"></companion-form>
    <dynamic-filter-modal
      ref="modalFilter"
      context="participants"
      @filtered="applyFilters"
    />

    <!-- MODAL ATRIBUIR MANUAL -->
    <modal-assign-manual
      v-model="modalAssignManual"
      :selectedParticipants="selectedParticipants"
      @assigned="onAssigned"
    />

    <!-- MODAL DISTRIBUIR AUTOMÁTICO -->
    <modal-assign-auto
      v-model="modalAssignAuto"
      @distributed="onDistributed"
    />
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import ModalForm from './Form'
import CompanionForm from './ModalForm'
import DynamicFilterModal from '@/components/modals/filters/DynamicFilter'
import participantStatistic from '@/components/widgets/participant-statistic'
import ModalAssignManual from './modals/ModalAssignManual'
import ModalAssignAuto from './modals/ModalAssignAuto'
import appConfig from '@/app.config'
import Swal from 'sweetalert2'
import { successMessage, errorMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'
import { buildApiParams } from '@/modules/utils/filters'
import http from '@/http'
import services from './services'
import JourneyProgressCell from './JourneyProgressCell'
import GroupBadges from '@/components/GroupBadges'

const STANDARD_OPTIONAL_COLUMNS = [
  { key: 'cpf', label: 'CPF', source: 'standard' },
  { key: 'phone', label: 'Telefone', source: 'standard' },
  { key: 'city', label: 'Cidade', source: 'standard' },
  { key: 'state', label: 'UF', source: 'standard' },
  { key: 'gender', label: 'Gênero', source: 'standard' },
  { key: 'birth_date', label: 'Data de Nascimento', source: 'standard' },
  { key: 'badge_name', label: 'Nome no Crachá', source: 'standard' },
  { key: 'confirmation_code', label: 'Cód. Confirmação', source: 'standard' },
  { key: 'tag_name', label: 'Tag', source: 'standard' },
  { key: 'has_companion', label: 'Acompanhantes', source: 'standard' }
]

const FIXED_COLUMNS = [
  { key: 'name', label: 'Nome / E-mail' },
  { key: 'group', label: 'Grupo' },
  { key: 'inscricao', label: 'Inscrição' },
  { key: 'atualizacao', label: 'Atualização' },
  { key: 'journey_progress', label: 'Jornada', toggleable: true },
  { key: 'status', label: 'Status' }
]

const JOURNEY_STORAGE_KEY = 'participant-journey-visible'

const STORAGE_KEY = 'participant-columns'

export default {
  components: {
    Layout,
    participantStatistic,
    ModalForm,
    CompanionForm,
    DynamicFilterModal,
    ModalAssignManual,
    ModalAssignAuto,
    JourneyProgressCell,
    GroupBadges
  },
  name: 'Participantes',
  page: {
    title: 'Participantes',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      timeout: 60000,
      search: '',
      statusClass: ['badge-dark', 'badge-primary', 'badge-warning', 'badge-success', 'badge-danger', 'badge-secondary'],
      modalForm: false,
      modalFormC: false,
      modalDetail: false,
      params: {},
      activeFilters: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      idParticipant: null,
      showMyParticipants: false,
      myParticipantsCount: 0,
      allParticipantsCount: 0,
      selectionMode: false,
      selectedParticipants: [],
      modalAssignManual: false,
      modalAssignAuto: false,
      // Colunas personalizáveis
      availableColumns: [...STANDARD_OPTIONAL_COLUMNS],
      selectedColumnKeys: [],
      tempSelectedKeys: [],
      columnSearch: '',
      columnsLoaded: false,
      showColumnDropdown: false,
      colAccFixedOpen: true,
      colAccOptionalOpen: false,
      colAccRcOpen: false,
      journeyProgressMap: {},
      journeyColumnVisible: true,
      hasJourneys: false,
      // WA Notifications
      pendingWaConversations: [],
      waChannel: null,
      waMessengerEnabled: false
    }
  },
  computed: {
    ...mapState('participant', ['participants', 'pagination']),
    ...mapState('settings', ['statusList', 'refstatusList']),
    ...mapState('auth', ['user']),
    rows () {
      return this.pagination.total
    },
    lastWaContactName () {
      if (!this.pendingWaConversations.length) return ''
      const last = this.pendingWaConversations[this.pendingWaConversations.length - 1]
      return last.contact_name || last.phone || ''
    },
    hasActiveFilters () {
      return Object.keys(this.activeFilters).length > 0
    },
    activeFilterCount () {
      return Object.keys(this.activeFilters).length
    },
    // Agrupa visualmente os clusters de duplicidade quando o filtro está ativo.
    // Como o backend já devolve as linhas ordenadas por CPF/nome, aqui só mapeamos
    // id -> { color, chip } pra desenhar a barra lateral + o chip da "cola".
    duplicateClusters () {
      const mode = this.activeFilters && this.activeFilters.duplicate
      const result = {}
      const list = this.participants
      if (!mode || !list || !list.length) return result

      const norm = s => (s || '').toString().trim().toLowerCase()
      const useCpf = mode === 'cpf' || mode === 'both'
      const useName = mode === 'name' || mode === 'both'

      // union-find: une cadastros que compartilham CPF OU nome — de forma TRANSITIVA.
      // No modo misto, se A~B por CPF e B~C por nome, A, B e C caem no MESMO cluster
      // (mesma cor). É isso que evita o Flavio agrupado em cima e outro solto embaixo.
      const parent = {}
      const find = (x) => { while (parent[x] !== x) { parent[x] = parent[parent[x]]; x = parent[x] } return x }
      const union = (a, b) => { const ra = find(a); const rb = find(b); if (ra !== rb) parent[ra] = rb }
      list.forEach(p => { parent[p.id] = p.id })

      const firstByCpf = {}
      const firstByName = {}
      const cpfCount = {}
      list.forEach(p => {
        if (useCpf && p.cpf) {
          cpfCount[p.cpf] = (cpfCount[p.cpf] || 0) + 1
          if (firstByCpf[p.cpf] != null) union(firstByCpf[p.cpf], p.id); else firstByCpf[p.cpf] = p.id
        }
        if (useName && p.name) {
          const n = norm(p.name)
          if (firstByName[n] != null) union(firstByName[n], p.id); else firstByName[n] = p.id
        }
      })

      // Cor por componente conectado (mesma cor = mesmo cluster)
      const palette = ['#4e73df', '#1cc88a', '#f6c23e', '#e74a3b', '#6f42c1', '#fd7e14', '#20c9a6', '#e83e8c']
      const colorByRoot = {}
      let colorIdx = 0
      list.forEach(p => {
        const root = find(p.id)
        if (!(root in colorByRoot)) { colorByRoot[root] = palette[colorIdx % palette.length]; colorIdx++ }
        // chip mostra o CPF quando a "cola" é o CPF (há outro com o mesmo CPF na página)
        const chip = (useCpf && p.cpf && cpfCount[p.cpf] > 1) ? p.cpf : null
        result[p.id] = { color: colorByRoot[root], chip, sortKey: String(root) }
      })

      return result
    },
    // Ordena a listagem por cluster QUANDO o filtro de duplicidade está ativo, pra
    // que os pares (CPF ou nome) fiquem sempre adjacentes — independente da ordem
    // que veio do backend. Como o backend devolve todos os duplicados numa página
    // só, isso agrupa o conjunto inteiro sem risco de par dividido entre páginas.
    displayParticipants () {
      const mode = this.activeFilters && this.activeFilters.duplicate
      if (!mode || !this.participants) return this.participants
      const clusters = this.duplicateClusters
      return [...this.participants].sort((a, b) => {
        const ka = (clusters[a.id] && clusters[a.id].sortKey) || '~'
        const kb = (clusters[b.id] && clusters[b.id].sortKey) || '~'
        if (ka < kb) return -1
        if (ka > kb) return 1
        return 0
      })
    },
    isUserAdmin () {
      return this.$store.getters['auth/isAdmin']
    },
    isUserMaster () {
      return this.$store.getters['auth/isMaster']
    },
    statusVariant () {
      return this.statusClass.map(c => c.replace('badge-', ''))
    },
    fixedColumns () {
      return FIXED_COLUMNS.filter(c => {
        if (c.key === 'journey_progress') return this.hasJourneys
        return true
      })
    },
    visibleFixedColumns () {
      return this.fixedColumns.filter(c => {
        if (c.key === 'journey_progress') return this.journeyColumnVisible
        return true
      })
    },
    filteredColumns () {
      const base = this.availableColumns.filter(c => c.source !== 'rc_field')
      if (!this.columnSearch) return base
      const q = this.columnSearch.toLowerCase()
      return base.filter(c => c.label.toLowerCase().includes(q))
    },
    filteredRcColumns () {
      const base = this.availableColumns.filter(c => c.source === 'rc_field')
      if (!this.columnSearch) return base
      const q = this.columnSearch.toLowerCase()
      return base.filter(c => c.label.toLowerCase().includes(q))
    },
    activeColumns () {
      return this.selectedColumnKeys
        .map(key => this.availableColumns.find(c => c.key === key))
        .filter(Boolean)
    },
    needsFormDataInclude () {
      return this.activeColumns.some(c => c.source === 'form_field' || c.source === 'card_field')
    },
    needsRcInclude () {
      return this.activeColumns.some(c => c.source === 'rc_field')
    },
    needsJourneyInclude () {
      return this.hasJourneys && this.journeyColumnVisible
    },
    searchColumns () {
      return this.activeColumns.map(c => {
        if (c.source === 'standard') return { type: 'standard', field: c.key }
        if (c.source === 'rc_field') return { type: 'rc_field', field: c.rcField }
        if (c.source === 'form_field') return { type: 'form_field', field_id: c.fieldId }
        if (c.source === 'card_field') return { type: 'card_field', field_id: c.fieldId }
        return null
      }).filter(Boolean)
    },
    searchPlaceholder () {
      const labels = ['Nome', 'E-mail', 'CPF']
      this.activeColumns.forEach(c => {
        if (labels.length < 5) labels.push(c.label)
      })
      const visible = labels.slice(0, 5).join(', ')
      const suffix = labels.length > 5 ? '...' : ''
      return `Pesquise por ${visible}${suffix} e pressione 'ENTER'`
    }
  },
  async mounted () {
    // Restaurar colunas selecionadas do localStorage
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved) {
      try {
        this.selectedColumnKeys = JSON.parse(saved)
        this.tempSelectedKeys = [...this.selectedColumnKeys]
      } catch (e) {}
    }

    // Restaurar visibilidade da coluna Jornada
    const savedJourney = localStorage.getItem(JOURNEY_STORAGE_KEY)
    if (savedJourney !== null) {
      this.journeyColumnVisible = savedJourney !== 'false'
    }

    // Verificar se existem jornadas cadastradas
    await this.checkHasJourneys()

    // Se há colunas dinâmicas salvas, buscar campos da API eagerly
    const hasDynamicKeys = this.selectedColumnKeys.some(k => k.startsWith('form_field_') || k.startsWith('card_field_') || k.startsWith('rc_field_'))
    if (hasDynamicKeys) {
      await this.fetchAvailableColumns()
    }

    this.updateList()
    this.loadCounts()
    this.timeout = setInterval(() => {
      this.updateList()
    }, 60000)

    // Listener para abrir participante (usado pelo Form.vue ao clicar em acompanhante)
    this.$root.$on('open-participant', (participantId) => {
      this.$refs.formParticipant.open(participantId)
      this.modalForm = true
      this.idParticipant = participantId
    })
    this.totalRows = this.pagination.total
    this.currentPage = this.pagination.current_page
    this.loading = false
    this.GetStatus()
    this.GetRefStatus()

    document.addEventListener('click', this.closeColumnDropdown)

    // WA Notifications: check settings and setup Pusher
    this.setupWaNotifications()
  },
  beforeDestroy () {
    this.cancelAutoUpdate()
    document.removeEventListener('click', this.closeColumnDropdown)
    this.$root.$off('open-participant')
    this.tearWaPusher()
  },
  methods: {
    ...mapActions('settings', { GetStatus: 'GetStatusList' }),
    ...mapActions('settings', { GetRefStatus: 'GetRefStatusList' }),
    ...mapActions('participant', ['getAll', 'getMyParticipants', 'changeStatus']),

    cancelAutoUpdate () {
      clearInterval(this.timeout)
    },

    // ── WA Notification Methods ──
    async setupWaNotifications () {
      try {
        const res = await http.get('/admin/settings/wa')
        const wa = res.data && res.data.data ? res.data.data : res.data
        if (!wa || parseInt(wa.whatsapp) !== 1 || !wa.wa_messenger) return
        this.waMessengerEnabled = true

        // Restore pending from localStorage
        const saved = localStorage.getItem('wa_pending_notifications')
        if (saved) {
          try { this.pendingWaConversations = JSON.parse(saved) } catch (e) {}
        }

        const slug = process.env.VUE_APP_EVENT_NAME || ''
        const channel = slug ? 'wa-messenger-' + slug : 'wa-messenger'
        this.waChannel = this.$pusher.subscribe(channel)
        this.waChannel.bind('new-message', this.onWaMessage)
      } catch (e) {
        // Settings not available, skip
      }
    },
    tearWaPusher () {
      if (this.waChannel) {
        this.waChannel.unbind_all()
        this.$pusher.unsubscribe(this.waChannel.name)
        this.waChannel = null
      }
    },
    onWaMessage (data) {
      const conv = data.conversation || {}
      const msg = data.message || {}

      // Filtrar: só mensagens inbound que precisam de atencao humana
      const isInbound = msg.sender === 'contact' || msg.direction === 'inbound'
      const needsHuman = !conv.assigned_admin_id && conv.status !== 'bot'
      const isHandoff = msg.message_type === 'system' && (msg.content || '').toLowerCase().includes('transferiu')

      if (!isInbound && !isHandoff) return
      if (!needsHuman && !isHandoff) return

      // Nao duplicar
      const convId = data.conversation_id || conv.id
      if (this.pendingWaConversations.find(c => c.id === convId)) return

      this.pendingWaConversations.push({
        id: convId,
        contact_name: conv.contact_name,
        phone: conv.phone,
        preview: msg.content ? msg.content.substring(0, 80) : '',
        time: new Date().toISOString()
      })

      // Persist
      localStorage.setItem('wa_pending_notifications', JSON.stringify(this.pendingWaConversations))

      // Play sound
      this.playWaNotificationSound()
    },
    playWaNotificationSound () {
      try {
        var ctx = new (window.AudioContext || window.webkitAudioContext)()
        var osc = ctx.createOscillator()
        var gain = ctx.createGain()
        osc.connect(gain)
        gain.connect(ctx.destination)
        osc.frequency.value = 880
        osc.type = 'sine'
        gain.gain.setValueAtTime(0.3, ctx.currentTime)
        gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.3)
        osc.start(ctx.currentTime)
        osc.stop(ctx.currentTime + 0.3)
        var osc2 = ctx.createOscillator()
        var gain2 = ctx.createGain()
        osc2.connect(gain2)
        gain2.connect(ctx.destination)
        osc2.frequency.value = 1320
        osc2.type = 'sine'
        gain2.gain.setValueAtTime(0.2, ctx.currentTime + 0.15)
        gain2.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.4)
        osc2.start(ctx.currentTime + 0.15)
        osc2.stop(ctx.currentTime + 0.4)
      } catch (e) { /* silent */ }
    },
    goToMessenger () {
      this.$router.push('/wa/messenger')
    },
    dismissWaNotifications () {
      this.pendingWaConversations = []
      localStorage.removeItem('wa_pending_notifications')
    },
    // ── End WA Notification Methods ──

    toggleView (showMine) {
      this.showMyParticipants = showMine
      this.selectionMode = false
      this.selectedParticipants = []
      this.currentPage = 1
      this.updateList()
    },

    async loadCounts () {
      try {
        const [myRes, allRes] = await Promise.all([
          services.getMyParticipants({ limit: 1 }),
          services.list({ limit: 1 })
        ])
        this.myParticipantsCount = myRes.data.meta?.pagination?.total || 0
        this.allParticipantsCount = allRes.data.meta?.pagination?.total || 0
      } catch (error) {
        console.error('Erro ao carregar contagens')
      }
    },

    enableSelection () {
      this.selectionMode = true
      this.selectedParticipants = []
    },

    cancelSelection () {
      this.selectionMode = false
      this.selectedParticipants = []
    },

    toggleSelection (participantId) {
      const index = this.selectedParticipants.indexOf(participantId)
      if (index > -1) {
        this.selectedParticipants.splice(index, 1)
      } else {
        this.selectedParticipants.push(participantId)
      }
    },

    toggleSelectAll () {
      if (this.selectedParticipants.length === this.participants.length) {
        this.selectedParticipants = []
      } else {
        this.selectedParticipants = this.participants.map(p => p.id)
      }
    },

    isSelected (participantId) {
      return this.selectedParticipants.includes(participantId)
    },

    handleRowClick (participant) {
      if (this.selectionMode) {
        this.toggleSelection(participant.id)
      } else {
        this.editParticipant(participant.id, participant.event_companion, participant.travel_companion)
      }
    },

    openAssignManual () {
      if (this.selectedParticipants.length === 0) {
        errorMessage('Selecione ao menos uma ficha')
        return
      }
      this.modalAssignManual = true
    },

    openAssignAuto () {
      this.modalAssignAuto = true
    },

    onAssigned () {
      this.modalAssignManual = false
      this.cancelSelection()
      this.updateList()
      this.loadCounts()
    },

    onDistributed () {
      this.modalAssignAuto = false
      this.updateList()
      this.loadCounts()
    },

    showFilters () {
      this.$refs.modalFilter.open()
    },

    editParticipant (id, companionEvent, companionTravel) {
      if (!companionEvent && !companionTravel) {
        this.$refs.formParticipant.open(id)
        this.modalForm = true
        this.idParticipant = id
        return
      }
      this.$refs.formCompanion.open(id)
      this.modalFormC = true
      this.idParticipant = id
    },

    applyFilters (filters) {
      this.activeFilters = filters || {}
      this.currentPage = 1
      this.getReport()
    },

    clearFilters () {
      this.activeFilters = {}
      this.currentPage = 1
      this.getReport()
    },

    getReport () {
      let include = 'group'
      if (this.needsFormDataInclude) {
        include += ',formData'
      }
      if (this.needsRcInclude) {
        include += ',registrationControlItem'
      }

      const params = buildApiParams({
        include: include,
        search: this.search || null,
        search_columns: this.search && this.searchColumns.length ? JSON.stringify(this.searchColumns) : null,
        limit: this.perPage,
        page: this.currentPage
      }, this.activeFilters)

      this.params = params

      let loader = this.$loading.show()

      if (this.showMyParticipants) {
        this.getMyParticipants(params).then((res) => {
          this.totalRows = this.pagination.total
          this.fetchJourneyProgress()
          loader.hide()
        }).catch(error => {
          console.log(error)
          loader.hide()
        })
      } else {
        this.getAll(params).then((res) => {
          this.totalRows = this.pagination.total
          this.fetchJourneyProgress()
          loader.hide()
        }).catch(error => {
          console.log(error)
          loader.hide()
        })
      }
    },

    doSearch () {
      this.currentPage = 1
      this.getReport()
    },

    changePage (page) {
      this.currentPage = page
      this.getReport()
    },

    updateList () {
      this.getReport()
    },

    async checkHasJourneys () {
      try {
        const res = await http.get('/admin/journeys', { params: { limit: 1 } })
        const total = res.data?.meta?.pagination?.total || res.data?.total || 0
        this.hasJourneys = total > 0
      } catch (err) {
        this.hasJourneys = false
      }
    },

    toggleJourneyColumn () {
      this.journeyColumnVisible = !this.journeyColumnVisible
      localStorage.setItem(JOURNEY_STORAGE_KEY, this.journeyColumnVisible)
      if (this.journeyColumnVisible) {
        this.fetchJourneyProgress()
      }
    },

    async fetchJourneyProgress () {
      if (!this.needsJourneyInclude || !this.participants.length) {
        this.journeyProgressMap = {}
        return
      }
      try {
        const ids = this.participants.map(p => p.id)
        const res = await services.getJourneyProgress(ids)
        this.journeyProgressMap = res.data || {}
      } catch (err) {
        console.error('Erro ao carregar progresso de jornadas:', err)
        this.journeyProgressMap = {}
      }
    },

    // === Colunas Personalizáveis ===
    closeColumnDropdown () {
      this.showColumnDropdown = false
    },

    openColumnSelector () {
      this.fetchAvailableColumns()
      this.tempSelectedKeys = [...this.selectedColumnKeys]
      this.columnSearch = ''
      this.showColumnDropdown = !this.showColumnDropdown
    },

    async fetchAvailableColumns () {
      if (this.columnsLoaded) return
      try {
        const { fields, card } = await services.getAvailableColumns()

        let columns = [...STANDARD_OPTIONAL_COLUMNS]

        // Form builder fields
        if (fields?.form_fields) {
          fields.form_fields.forEach(group => {
            group.fields.forEach(f => {
              columns.push({
                key: `form_field_${f.id}`,
                label: f.label,
                source: 'form_field',
                fieldId: f.id,
                formName: group.form.name
              })
            })
          })
        }

        // Card internal fields
        if (card?.tabs) {
          card.tabs.forEach(tab => {
            (tab.fields || []).forEach(f => {
              if (f.field_source === 'internal' && f.field_config) {
                columns.push({
                  key: `card_field_${f.id}`,
                  label: f.field_config.label || f.field_config.name,
                  source: 'card_field',
                  fieldId: f.id
                })
              }
            })
          })
        }

        // Registration Control fields
        if (fields?.registration_control) {
          const rc = fields.registration_control
          rc.fields.forEach(f => {
            columns.push({
              key: `rc_field_${f.rc_field}`,
              label: f.label,
              source: 'rc_field',
              rcField: f.rc_field,
              controlName: rc.control_name
            })
          })
        }

        this.availableColumns = columns
        this.columnsLoaded = true
      } catch (err) {
        console.error('Erro ao carregar colunas disponíveis:', err)
      }
    },

    toggleTempColumn (key) {
      const idx = this.tempSelectedKeys.indexOf(key)
      if (idx > -1) this.tempSelectedKeys.splice(idx, 1)
      else this.tempSelectedKeys.push(key)
    },

    applyColumns () {
      this.selectedColumnKeys = [...this.tempSelectedKeys]
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.selectedColumnKeys))
      this.showColumnDropdown = false
      this.updateList()
    },

    resetColumns () {
      this.tempSelectedKeys = []
      this.applyColumns()
    },

    getColumnValue (participant, column) {
      if (column.source === 'standard') {
        return participant[column.key] ?? '-'
      }
      if (column.source === 'rc_field') {
        const rcItem = participant.registrationControlItem?.data
        if (!rcItem) return '-'
        if (column.rcField === 'identifier') return rcItem.identifier ?? '-'
        if (column.rcField === 'name') return rcItem.name ?? '-'
        if (column.rcField === 'group') return rcItem.group_name ?? '-'
        if (column.rcField === 'tag_bundle') return rcItem.tag_bundle_name ?? '-'
        return rcItem.data?.[column.rcField] ?? '-'
      }
      if (!participant.formData?.data) return '-'
      const entry = participant.formData.data.find(fd => {
        if (column.source === 'form_field') return fd.form_field_id === column.fieldId
        if (column.source === 'card_field') return fd.card_field_id === column.fieldId
        return false
      })
      return entry ? entry.data : '-'
    },

    async quickToggleStatus (participant, status) {
      if (parseInt(participant.status) === parseInt(status)) return

      if (status === 2) {
        Swal.fire({
          title: 'Você tem certeza?',
          input: 'select',
          html: `Mudar status de <b>${this.statusList[participant.status]}</b> para <b>${this.statusList[status]}</b>`,
          inputOptions: this.refstatusList,
          icon: 'question',
          inputPlaceholder: 'Selecione motivo da pendência',
          showCancelButton: true,
          confirmButtonColor: '#388741',
          cancelButtonColor: '#4a4848',
          cancelButtonText: 'CANCELAR',
          confirmButtonText: 'SIM, MUDAR STATUS',
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (value) {
                resolve()
              } else {
                resolve('Você precisa selecionar o motivo')
              }
            })
          }
        }).then(result => {
          if (result.value) {
            this.changeStatus({ id: participant.id, status, refSatus: result.value }).then(() => {
              successMessage('Sucesso: Status atualizado.', 2500)
              if (status === 1) {
                services.autoAssignOnStatusChange(participant.id).catch(() => {})
              }
              this.updateList()
              this.loadCounts()
            }).catch((err) => {
              errorMessage('Alerta: ' + err.message)
            })
          }
        })
      } else {
        Swal.fire({
          title: 'Você tem certeza?',
          html: `Mudar status de <b>${this.statusList[participant.status]}</b> para <b>${this.statusList[status]}</b>`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#388741',
          cancelButtonColor: '#4a4848',
          cancelButtonText: 'CANCELAR',
          confirmButtonText: 'SIM, MUDAR STATUS'
        }).then(result => {
          if (result.value) {
            this.changeStatus({ id: participant.id, status }).then(() => {
              successMessage('Sucesso: Status atualizado.', 2500)
              if (status === 1) {
                services.autoAssignOnStatusChange(participant.id).catch(() => {})
              }
              this.updateList()
              this.loadCounts()
            }).catch((err) => {
              errorMessage('Alerta: ' + err.message)
            })
          }
        })
      }
    }
  }
}
</script>

<style scoped>
/* WA Notification Banner */
.wa-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 4px rgba(37, 211, 102, 0.08);
}
.wa-banner:hover {
  border-color: #d1d5db;
  box-shadow: 0 4px 16px rgba(37, 211, 102, 0.15);
}
.wa-banner-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.wa-banner-badge {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #25d366;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}
.wa-banner-badge i {
  font-size: 20px;
  color: #fff;
}
.wa-banner-dot {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ef4444;
  border: 2px solid #fff;
  animation: wa-dot-pulse 1.5s ease-in-out infinite;
}
.wa-banner-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.wa-banner-label {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  line-height: 1.3;
}
.wa-banner-detail {
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wa-banner-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: 16px;
}
.wa-banner-cta {
  font-size: 12px;
  font-weight: 500;
  color: #25d366;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 6px 12px;
  border-radius: 6px;
  background: #f0fdf4;
  transition: all 0.15s;
}
.wa-banner:hover .wa-banner-cta {
  background: #dcfce7;
}
.wa-banner-cta i {
  font-size: 15px;
  transition: transform 0.15s;
}
.wa-banner:hover .wa-banner-cta i {
  transform: translateX(2px);
}
.wa-banner-close {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: #d1d5db;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.15s;
}
.wa-banner-close:hover {
  background: #f3f4f6;
  color: #6b7280;
}
@keyframes wa-dot-pulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.3); opacity: 0.7; }
}
.wa-notif-slide-enter-active {
  animation: wa-slide-in 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
.wa-notif-slide-leave-active {
  animation: wa-slide-in 0.2s ease-in reverse;
}
@keyframes wa-slide-in {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
}
@media (max-width: 640px) {
  .wa-banner { flex-wrap: wrap; gap: 10px; }
  .wa-banner-right { margin-left: 50px; }
  .wa-banner-cta { font-size: 11px; padding: 5px 10px; }
}

.action-bar {
  gap: 0;
  margin-left: -4px;
  margin-right: -4px;
}
.action-bar > [class*="col"] {
  padding-left: 4px;
  padding-right: 4px;
}
.link { cursor: pointer; }
.inativado { background: #f7ebeb }
.table-active {
  background-color: #e3f2fd !important;
}
.table-responsive { min-height: 300px;}
.float-sm-end { float: right }

/* Estilo dos itens do dropdown */
.dropdown-item small {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.8rem;
}

.btn-outline-secondary {
  border-color: #ced4da !important;
}

/* Wrapper de status na tabela */
.status-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  width: 140px;
}
.status-dropdown {
  width: 100%;
}
.status-dropdown ::v-deep .btn-group {
  display: flex;
  width: 140px;
}
.status-dropdown ::v-deep .btn {
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.status-dropdown ::v-deep .btn:not(.dropdown-toggle-split) {
  flex: 1 1 auto;
  text-align: center;
  padding: 0.35rem 0.5rem;
  min-width: 0;
}
.status-dropdown ::v-deep .dropdown-toggle-split {
  flex: 0 0 28px;
  width: 28px;
  padding: 0.35rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.status-ref {
  display: block;
  width: 100%;
  margin-top: 3px;
  text-align: center;
}

/* Column Toggle Button */
.column-toggle-btn {
  border: 1px solid #d2d6dc;
  background: #fff;
  color: #495057;
  font-size: 13px;
  font-weight: 500;
  padding: 0.47rem 0.85rem;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.15s ease;
}
.column-toggle-btn:hover {
  background: #f4f5f7;
  border-color: #c0c4cc;
  color: #343a40;
}
.column-toggle-btn.column-toggle-active {
  border-color: #556ee6;
  color: #556ee6;
  background: #eef1fd;
}
.column-toggle-btn.column-toggle-active:hover {
  background: #e1e6fa;
}
.column-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #556ee6;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  padding: 0 5px;
  margin-left: 2px;
}

/* Column Selector Dropdown */
.column-selector-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1050;
  width: 320px;
  max-height: 480px;
  background: #fff;
  border: 1px solid #e2e5e8;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.cs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}
.cs-search {
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
}
.cs-sections-scroll {
  overflow-y: auto;
  flex: 1;
  max-height: 340px;
}
.cs-accordion {
  border-bottom: 1px solid #f0f0f0;
}
.cs-accordion:last-child {
  border-bottom: none;
}
.cs-accordion-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  cursor: pointer;
  user-select: none;
}
.cs-accordion-header:hover {
  background: #f8f9fa;
}
.cs-accordion-header .mdi {
  font-size: 16px;
  color: #999;
}
.cs-accordion-header small.text-uppercase {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
}
.cs-accordion-count {
  margin-left: auto;
  font-size: 11px;
  color: #999;
  background: #f0f0f0;
  padding: 1px 7px;
  border-radius: 10px;
}
.cs-accordion-body {
  padding-bottom: 4px;
}
.cs-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  cursor: pointer;
  font-size: 13px;
}
.cs-item:hover {
  background: #f8f9fa;
}
.cs-item.disabled {
  opacity: 0.6;
  cursor: default;
}
.cs-item input[type="checkbox"] {
  accent-color: #556ee6;
}
.cs-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 16px;
  border-top: 1px solid #eee;
}
</style>
